import { DeliverablesRollup } from '@/components/rollups/Rollups';
import { api } from '@/lib/api';
import { useWorkspaceCtx } from './WorkspaceLayout';

/** Every deliverable in this engagement, newest first. */
export function WorkspaceDeliverablesTab() {
  const { company, workspace } = useWorkspaceCtx();
  return (
    <DeliverablesRollup
      fetchKey={`ws-${workspace.id}`}
      fetch={() => api.listWorkspaceDeliverables(workspace.id)}
      companySlug={company.slug}
    />
  );
}
